import { useState } from 'react';
import z from 'zod';
import { lt, useSafeUrlState, useToggle } from '@mews/framework';
import { Divider, IconName, Tab } from '@optimus-web/core';
import { TextKey, ActionType } from '@mews-commander/enums';
import { compactArray } from '@mews/fp';
import { ModalWrapper, NewModalBodyWrapper, OptimusProvider } from '@mews-commander/ui';
import { ExportsPageTabs } from '../constants';
import ModalHeader from '../../../legacy/React/Components/Common/ModalHeader';
import { HeadingAction } from '../../../legacy';
import { SchedulesTable } from './ExportsTable/SchedulesTable';
import { ExportFiterPage } from './ExportsFilterPage';

const urlSchema = z.object({
    tab: z.string().optional(),
});

export const ExportsPage = () => {
    const [showSidebar, toggleSidebar] = useToggle({ initialValue: false });
    const toggleSidebarAction: HeadingAction = {
        type: ActionType.Custom,
        icon: IconName.Filter,
        text: lt('Filter'),
        onClick: toggleSidebar,
    };
    const [urlState, setUrlState] = useSafeUrlState(urlSchema);
    const handleTabClick = (_e: React.MouseEvent, value: string) => {
        setActiveTab(value);
        setUrlState({ tab: value });
    };
    const [activeTab, setActiveTab] = useState(urlState?.tab || ExportsPageTabs.History);

    const tabs = compactArray([
        <Tab
            key={ExportsPageTabs.History}
            id={ExportsPageTabs.History}
            label={lt(TextKey.History)}
            value={ExportsPageTabs.History}
        />,
        <Tab
            key={ExportsPageTabs.Scheduled}
            id={ExportsPageTabs.Scheduled}
            label={lt(TextKey.Scheduled)}
            value={ExportsPageTabs.Scheduled}
        />,
    ]);
    return (
        <OptimusProvider density="spacious">
            <ModalWrapper>
                <ModalHeader
                    actions={activeTab === ExportsPageTabs.Scheduled ? [] : [toggleSidebarAction]}
                    shadowed={false}
                    tabsConfig={{
                        tabs,
                        activeTabValue: activeTab,
                        handleTabClick,
                        inline: true,
                    }}
                    title={lt(TextKey.ExportPlural)}
                />
                <Divider />
                <NewModalBodyWrapper padded>
                    {activeTab === ExportsPageTabs.History ? (
                        <ExportFiterPage showSidebar={showSidebar} toggleSidebar={toggleSidebar} />
                    ) : null}
                    {activeTab === ExportsPageTabs.Scheduled ? <SchedulesTable /> : null}
                </NewModalBodyWrapper>
            </ModalWrapper>
        </OptimusProvider>
    );
};
